module.exports = __webpack_public_path__ + "static/media/tap_07_img04.dad51690.png";